import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { getPlannerReady, TPlannerReady } from "../../services/modules/planner";
import { useMemo } from "react";
import { useRpc } from "../../context/RpcContext";

type TPlannerReadyRes = {
  readyList: Array<TPlannerReady>;
};

export const usePlannerReady = () => {
  const qClient = useQueryClient();
  const { wsOpened } = useRpc();

  const { data: plannerReady, isLoading: isPlanerReadyLoading } =
    useQuery<TPlannerReadyRes>({
      queryKey: ["plannerReady"],
      queryFn: () => getPlannerReady(),
      enabled: wsOpened,
    });

  const { mutateAsync: updatePlannerReady, isPending: isUpdating } =
    useMutation({
      mutationKey: ["update planner"],
      mutationFn: () => getPlannerReady(),
      onSuccess: (newData) => {
        qClient.setQueryData<TPlannerReadyRes>(["plannerReady"], () => {
          return newData;
        });
      },
    });

  return useMemo(
    () => ({
      plannerReady,
      isPlanerReadyLoading,
      updatePlannerReady,
      isUpdating,
    }),
    [plannerReady, isPlanerReadyLoading, updatePlannerReady, isUpdating],
  );
};
